import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, concatMap, map, tap } from 'rxjs/operators';

import { AdminBackend } from '@libs/src/admin/admin.backend';

import { LoadProfile } from './profile-store/profile.actions';
import { Account } from '@libs/src/models/account.model';

import { IAppState } from '../app.state';

export const ProfileAPIUrl = (profileSlug: string) =>
  `/api/accounts/${profileSlug}`;
const ReportProfileAPIUrl = (profileSlug: string) =>
  `/api/accounts/${profileSlug}/report`;

@Injectable()
export class ProfileService {
  constructor(
    private adminBackend: AdminBackend,
    private http: HttpClient,
    private router: Router,
    private store: Store<IAppState>,
  ) {}

  populate(profileSlug: string, user?: Account): Observable<any> {
    return this.getAccount(profileSlug).pipe(
      concatMap((response: { profile: Account }) => {
        const profile = response.profile;
        if (user.isAdmin) {
          return this.adminBackend.getAccount(response.profile).pipe(
            map((adminResponse: { item: Account }) => {
              return {
                ...adminResponse.item,
                ...profile,
              };
            }),
          );
        }
        return of(profile);
      }),
      tap((account: Account) => this.setProfile(account)),
      catchError(() => {
        this.router.navigate(['/not-found'], { skipLocationChange: true });
        return EMPTY;
      }),
    );
  }

  getAccount(slugOrId: string) {
    return this.http.get(ProfileAPIUrl(slugOrId));
  }

  setProfile(profile: any) {
    this.store.dispatch(LoadProfile(profile));
  }

  reportProfile(profile: any): Observable<any> {
    return this.http.put(ReportProfileAPIUrl(profile.slug), {});
  }
}
